/*
  Statuses 'active' and 'healthy' are equal. Status 'active' on the backend will be removed soon
 */
export const CLUSTER_STATUSES = {
  NOT_INSTALLED: 'absent',
  INSTALLED: 'active',
  ACTIVE: 'active',
  CRITICAL: 'critical',
  WARNING: 'warning',
  CONFIGURING: 'reconfiguring',
  DEPLOYING: 'deploying',
  DESTROYING: 'destroying',
  ERROR: 'error'
};

export const ACTIVE_CLUSTER_STATUSES = [
  CLUSTER_STATUSES.INSTALLED,
  CLUSTER_STATUSES.CONFIGURING,
  CLUSTER_STATUSES.ACTIVE,
  CLUSTER_STATUSES.CRITICAL,
  CLUSTER_STATUSES.WARNING,
];

export const COMPUTE_CLUSTER_CREATE_TASK = 'CreateComputeCluster';
export const COMPUTE_CLUSTER_UPDATE_TASK = 'UpdateComputeCluster';
export const COMPUTE_CLUSTER_DESTROY_TASK = 'DestroyComputeCluster';

export const DEFAULT_MAC_PREFIX = 'fa:16:3e';
export const DEFAULT_REDUNDANCY_M = 3;
